import { Component, Prop, h } from '@stencil/core';
import { IconType } from '../../utils/icon-types';

@Component({
  tag: 'biel-icon',
  styleUrl: 'biel-icon.css',
  shadow: true,
})
export class BielIcon {
  @Prop() type: IconType = 'biel';
  @Prop() width: string = '20';
  @Prop() height: string = '20';

  render() {
    return this.renderIcon();
  }

  private renderIcon() {
    switch (this.type) {
      case 'bot':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={this.width}
            height={this.height}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-bot"
            part="icon"
          >
            <path d="M12 8V4H8"></path>
            <rect width="16" height="12" x="4" y="8" rx="2"></rect>
            <path d="M2 14h2"></path>
            <path d="M20 14h2"></path>
            <path d="M15 13v2"></path>
            <path d="M9 13v2"></path>
          </svg>
        );

      case 'sparks':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={this.width}
            height={this.height}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-sparkles"
            part="icon"
          >
            <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.582a.5.5 0 0 1 0 .962L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"></path>
            <path d="M20 3v4"></path>
            <path d="M22 5h-4"></path>
            <path d="M4 17v2"></path>
            <path d="M5 18H3"></path>
          </svg>
        );

      case 'question-mark':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={this.width}
            height={this.height}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-circle-help"
            part="icon"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
            <path d="M12 17h.01"></path>
          </svg>
        );

      case 'user':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={this.width}
            height={this.height}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-user"
            part="icon"
          >
            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
        );

      case 'search':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={this.width}
            height={this.height}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-search"
            part="icon"
          >
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.3-4.3"></path>
          </svg>
        );

      case 'biel':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={this.width}
            height={this.height}
            viewBox="0 0 40 40"
            fill="currentColor"
            role="img"
            aria-label="Biel.ai mark"
            part="icon"
          >
            <rect x="6" y="8" width="20" height="5" rx="1.5"></rect>
            <rect x="6" y="17.5" width="28" height="5" rx="1.5"></rect>
            <rect x="6" y="27" width="14" height="5" rx="1.5"></rect>
            <rect x="30" y="27" width="5" height="5" rx="1.5"></rect>
          </svg>
        );

      default:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={this.width}
            height={this.height}
            viewBox="0 0 40 40"
            fill="currentColor"
            role="img"
            aria-label="Biel.ai mark"
            part="icon"
          >
            <rect x="6" y="8" width="20" height="5" rx="1.5"></rect>
            <rect x="6" y="17.5" width="28" height="5" rx="1.5"></rect>
            <rect x="6" y="27" width="14" height="5" rx="1.5"></rect>
            <rect x="30" y="27" width="5" height="5" rx="1.5"></rect>
          </svg>
        );
    }
  }
}
